/** Natural conversation closings when an interaction ends without further action. */

export const ASHLEY_CONVERSATION_CLOSINGS = Object.freeze([
  "Sounds good. Let me know if you need anything else.",
  "No problem. I'll be here if you need me.",
  "Alright. Have a great day.",
  "Okay. Just let me know if you'd like anything else.",
  "Sounds good. Talk to you later.",
]);

/**
 * @param {readonly string[]} [pool]
 * @param {() => number} [random]
 * @returns {string}
 */
export function pickAshleyConversationClosing(
  pool = ASHLEY_CONVERSATION_CLOSINGS,
  random = Math.random,
) {
  if (!pool.length) {
    return "Sounds good. Let me know if you need anything else.";
  }
  const index = Math.floor(random() * pool.length);
  return pool[Math.min(index, pool.length - 1)];
}
